import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import { CUSTOM_SKILL, PRIMARY_LANGUAGE, SECONDARY_LANGUAGE } from '../constants/categories';
const getPredefinedPrefixedLabel = (skill, category) => {
  const fields = {
    [PRIMARY_LANGUAGE]: I18n.text('skills-lib.skills.skillDropdown.primaryLanguageValue', {
      language: skill
    }),
    [SECONDARY_LANGUAGE]: I18n.text('skills-lib.skills.skillDropdown.secondaryLanguageValue', {
      language: skill
    }),
    [CUSTOM_SKILL]: skill
  };
  return fields[category];
};
export const getPrefixedSkillLabel = (category, skillName) => {
  const customLabel = getPredefinedPrefixedLabel(skillName, category.name);
  return customLabel || unescapedText('skills-lib.skills.skillDropdown.customCategoryValue', {
    categoryName: category.label,
    skillName
  });
};
export const isLanguage = category => [PRIMARY_LANGUAGE, SECONDARY_LANGUAGE].includes(category);
export const getCategoryText = category => {
  const fields = {
    [PRIMARY_LANGUAGE]: I18n.text('skills-lib.skills.skillDropdown.primaryLanguageHeader'),
    [SECONDARY_LANGUAGE]: I18n.text('skills-lib.skills.skillDropdown.secondaryLanguageHeader'),
    [CUSTOM_SKILL]: I18n.text('skills-lib.skills.skillDropdown.customHeader')
  };
  const text = fields[category];
  return text || '';
};